import React, { useEffect, useState, useCallback } from "react";
import { Label } from "reactstrap";
import { MultiSelect } from "react-multi-select-component";
import {
  EMPLOYEE_GET_EMPLOYEE,
  EMPLOYEE_GET_TEAM_EMPLOYEE_INCLUDE,
  GET_EMPLOYEE,
  GET_EMPLOYEES_LIST,
  GET_TEAM_EMPLOYEE_INCLUDE,
} from "../../helpers/url_helper";
import { APIClient } from "../../helpers/api_helper";
import { ToastContainer } from "react-toastify";
const api = new APIClient();

const EmployeeSelect = ({
  setEmployeeDetails,
  EmployeeDefault,
  setEmployeeDefault,
  teamIndu,
  setSelectedEmployeeOptions,
  setSelectedEmployeeOptions2,
  selectedEmployeeOptions,
  labelContent,
  error,
  setError,
  setEmployeeData,
  setEmployeeDefaultWithoutTeam,
  employeeConsolidated,
}) => {
  const storedValue = JSON.parse(localStorage.getItem("logintype"));
  const permissionType = JSON.parse(localStorage.getItem("permission"));
  const viewReportPermission = permissionType?.includes("VIEW_REPORT");

  const [employeesData, setEmployeesData] = useState([]);

  useEffect(() => {
    GetEmployeeData();
  }, []);

  // GET EMPLOYEE LIST API CALL
  const GetEmployeeData = async () => {
    try {
      let response = await api.get(`${GET_EMPLOYEES_LIST}`);
      if (response.success && response.success === true) {
        const apiResponse = response.data.data;
        setEmployeesData(apiResponse);
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  const emptyTeamRecords = employeesData.filter(
    (record) => record.team.length === 0 && record.status === "Active"
  );

  // Function to remove duplicate employees based on ID
  const removeDuplicates = (employees) => {
    const uniqueMap = new Map();
    employees.forEach(employee => {
      if (!uniqueMap.has(employee.value)) {
        uniqueMap.set(employee.value, employee);
      }
    });
    return Array.from(uniqueMap.values());
  };

  const fetchEmployeeData = useCallback(async () => {
    try {
      let response;
      if (storedValue === "employee" && permissionType.length > 0) {
        response = await api.get(EMPLOYEE_GET_EMPLOYEE);
      } else if (storedValue === "organization") {
        response = await api.get(GET_EMPLOYEE);
      }

      if (response?.success === true) {
        const apiResponse = response.data;
        const arnOption = (apiResponse || []).map((employee) => ({
          id: `${employee?._id}`,
          value: employee?._id?.trim(),
          label: employee?.fullName?.trim(),
        }));
        
        // Remove any duplicates before setting state
        const uniqueOptions = removeDuplicates(arnOption);
        
        if (setEmployeeDefaultWithoutTeam) {
          setEmployeeDefaultWithoutTeam(uniqueOptions);
        }
        if (setEmployeeData) {
          setEmployeeData(uniqueOptions);
        }
        setEmployeeDefault(uniqueOptions);
        setSelectedEmployeeOptions2(uniqueOptions);
        
        // Only reset if there are no applied filters
        if (employeeConsolidated) {
          setSelectedEmployeeOptions(employeeConsolidated);
        }
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  }, [storedValue, setEmployeeDefault, setSelectedEmployeeOptions, setSelectedEmployeeOptions2, employeesData, employeeConsolidated]);

  useEffect(() => {
    const teamType = teamIndu?.map((item) => item?.value);
    if (teamType?.length > 0) {
      fetchEEmployeeData(teamType);
    } else {
      fetchEmployeeData();
    }
  }, [teamIndu, employeesData]);

  const fetchEEmployeeData = useCallback(
    async (teamType) => {
      try {
        let response;
        const data = { teamName: teamType };

        // Fetch the appropriate data based on the team type
        if (storedValue === "employee") {
          response = await api.create(EMPLOYEE_GET_TEAM_EMPLOYEE_INCLUDE, data);
        } else if (storedValue === "organization") {
          response = await api.create(GET_TEAM_EMPLOYEE_INCLUDE, data);
        }

        if (response?.success === true) {
          const result = response.data;
          const apiResponse = result.sort((a, b) => a.fullName.localeCompare(b.fullName));

          let fetchedOptions = [];

          if (teamType && !teamType.includes('unAssignteam')) {
            fetchedOptions = apiResponse
              .map((item) => ({
                id: item?._id,
                value: item?._id?.trim(),
                label: item?.fullName?.trim(),
              }));
          } else if (teamType.includes('unAssignteam') && teamType.length === 1) {
            fetchedOptions = emptyTeamRecords
              .filter(employee => employee?.team?.length === 0)
              .map((employee) => ({
                id: employee?._id,
                value: employee?._id?.trim(),
                label: employee?.fullName?.trim(),
              }));
          } else {
            // Combine team employees and unassigned employees
            fetchedOptions = [
              ...apiResponse.map((item) => ({
                id: item?._id,
                value: item?._id?.trim(),
                label: item?.fullName?.trim(),
              })),
              ...emptyTeamRecords
                .filter(employee => employee?.team?.length === 0)
                .map((employee) => ({
                  id: employee?._id,
                  value: employee?._id?.trim(),
                  label: employee?.fullName?.trim(),
                }))
            ];
          }
          
          // Remove duplicates before setting state
          const uniqueOptions = removeDuplicates(fetchedOptions);
          
          if (setEmployeeDefault)
            setEmployeeDefault(uniqueOptions);
          if (setSelectedEmployeeOptions2)
            setSelectedEmployeeOptions2(uniqueOptions);

          if (!employeeConsolidated) {
            setSelectedEmployeeOptions(uniqueOptions);
          }
        }
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    },
    [storedValue, teamIndu, setEmployeeDefault, setSelectedEmployeeOptions, setSelectedEmployeeOptions2, emptyTeamRecords, employeeConsolidated]
  );

  const handleSelectChange = (selectedOptions) => {
    setSelectedEmployeeOptions(selectedOptions);
    if (setEmployeeDetails)
      setEmployeeDetails(selectedOptions);
  };

  // Custom filter for search without auto-selection
  const customFilterOptions = (options, filter) => {
    if (!filter) return options;
    
    return options.filter(option => 
      option.label.toLowerCase().includes(filter.toLowerCase())
    );
  };

  return (
    <>
      <ToastContainer />
      <Label>{labelContent}</Label>
      <MultiSelect
        disabled={!viewReportPermission && storedValue === "employee"}
        options={EmployeeDefault}
        value={selectedEmployeeOptions}
        onChange={handleSelectChange}
        labelledBy="Select"
        isCreatable={true}
        overrideStrings={{selectSomeItems: "Select Employee"}}
        hasSelectAll={true}
        filterOptions={(options, filter) => {
          return customFilterOptions(options, filter);
        }}
        className="classgroup"
      />
      {error && (
        <small
          className="sales-ninja-select-maltipale-lable"
          style={{
            color: "red",
            position: "absolute",
            bottom: "2px",
            left: "22px",
          }}
        >
          {error}
        </small>
      )}
    </>
  );
};

export default EmployeeSelect;